import { Component, ElementRef, Injector, Type } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";
import {
  BfxBlotterOrdersContextMenuService,
  BfxLadderBlotterOrdersContextMenuEvent,
} from "./bfx-blotter-orders-contextmenu.service";

import { BfxLadderBlotterContextMenuEventType } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";

import {
  BfxBlotterContextMenuItem,
  BfxBlotterOrdersContextMenuItem,
  OrderDataPrimaryLookupService,
} from "shared/cubiq-services";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-blotter-orders-context-menu",
  // TODO: move changes to base and drop
  templateUrl: "./bfx-blotter-orders-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BfxBlotterOrdersContextMenu extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  protected _menuItems: Array<BfxBlotterOrdersContextMenuItem>;

  constructor(
    injector: Injector,
    lookupService: OrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxBlotterOrdersContextMenuService> {
    return BfxBlotterOrdersContextMenuService;
  }

  public selectedMenuItem(item: BfxBlotterOrdersContextMenuItem, event?: any) {
    if (item.isEnabled) {
      this.menuService.fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        null,
        null,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }
}
